import { EXAMPLE_ACTION_TYPE } from '../constants'

// ---------------------------------------------
export const updateCountAction = (UPDATE_COUNT, payload) => ({
  type: EXAMPLE_ACTION_TYPE.UPDATE_COUNT,
  payload
})
export const addSensorsAction = (ADD_SENSORS, payload) => ({
  type: EXAMPLE_ACTION_TYPE.ADD_SENSORS,
  payload
})
export const updateMsgListAction = (UPDATE_MSGLIST, payload) => ({
  type: EXAMPLE_ACTION_TYPE.UPDATE_MSGLIST,
  payload
})
export const unshiftMsgListAction = (UNSHIFT_MSGLIST, payload) => ({
  type: EXAMPLE_ACTION_TYPE.UNSHIFT_MSGLIST,
  payload
})
export const addPageAction = (ADD_PAGE, payload) => ({
  type: 'addPage',
  payload
})
export const setIsScrollAction = (SET_IS_SCROLL, payload) => ({
  type: 'setIsScroll',
  payload
})
// ---------------------------------------------
export const changePageAction = (ADD_PAGE, payload) => ({
  type: 'changePageAction',
  payload: ADD_PAGE
})
